import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsurerEntryTab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20.75,
			cy: 20,
			r: 20,
			fill: "#FEF3E9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9086 18.87C20.8086 18.86 20.6886 18.86 20.5786 18.87C18.1986 18.79 16.3086 16.84 16.3086 14.44C16.3086 11.99 18.2886 10 20.7486 10C23.1986 10 25.1886 11.99 25.1886 14.44C25.1786 16.84 23.2886 18.79 20.9086 18.87Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9088 22.56C13.4887 24.18 13.4887 26.82 15.9088 28.43C18.6588 30.27 23.1688 30.27 25.9188 28.43C28.3388 26.81 28.3388 24.17 25.9188 22.56C23.1788 20.73 18.6688 20.73 15.9088 22.56Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgInsurerEntryTab;
